<!--安全状态（环形图，卡片数字）-->
<template>
  <div class="ss flex_row">
    <div id="ss_pie1" class="echarts"></div>
    <div class="right">
      <div class="title">已安全运行天数</div>
      <div class="numberbox">
        <span v-for="(item,i) in number" :key="i" >{{item}}</span>
      </div>
    </div>
  </div>

</template>

<script>
let echarts = require('echarts/lib/echarts')
import api from '@/apis/SecurityManagement'
export default {
  data() {
    return {
      number: [1,2,3,4],

    }
  },
  methods: {
    ss_pie1(hint) {
      let ss_pie1 = echarts.init(document.getElementById('ss_pie1'))
      ss_pie1.setOption({
        color: ['#00ccff', '#24ffb1', '#f4af1b', '#f95458', '#73c0de'],
        title: [
          {
            text: hint,
            x: 'center',
            top: '38%',
            textStyle: {
              color: '#24ffb1',
              fontSize: this.$echartsFontSize + 22, //表盘上的标题文字大小
              fontWeight: 'bold',
            },
          },
          {
            text: '设备运行状态',
            x: 'center',
            top: '55%',
            textStyle: {
              color: '#ccd0f2',
              fontSize: this.$echartsFontSize + 2, //表盘上的标题文字大小
              fontWeight: 'normal',
            },
          },
        ],
        series: [
          {
            name: '运行状态',
            type: 'pie',
            radius: ['62%', '72%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#0f26aa',
              borderWidth: 5,
            },
            label: { show: false },
            hoverAnimation: false,
            data: [
              { value: 25, name: '蓝色' },
              { value: 25, name: '绿色' },
              { value: 25, name: '橙色' },
              { value: 25, name: '红色' },
            ],
          },
          {
            name: '',
            type: 'pie',
            radius: [0, '60%'],
            center: ['50%', '50%'],
            label: { show: false },
            itemStyle: {
              normal: {
                color: new echarts.graphic.RadialGradient(
                  0.5,
                  0.5,
                  0.7,
                  [
                    {
                      offset: 0.5,
                      color: '#041889',
                    },
                    { offset: 1, color: '#010f5a' },
                  ],
                  false
                ),
              },
            },
            hoverAnimation: false,
            data: [100],
          },
        ],
      })
    },


  },
  mounted() {
    api
    .operation({
      params: {
        limit: 100,
        page: 1,
      },
    })
    .then((res) => {
      if (res.code === 10000) {
        if (res.data.list.length) {
          if (res.data.list[0].workingNum) {
            this.number = res.data.list[0].workingNum.toString().split('')
          } else {
            this.number = [0]
          }
          
          this.$nextTick(() => {
            switch ( res.data.list[0].status) {
              case 1:
                this.ss_pie1('优秀')
                break;
              case 2:
                this.ss_pie1('良好')
                break;
              case 3:
                this.ss_pie1('较差')
                break;
            
              default:
                this.ss_pie1('未知')
                break;
            }
            
          })          
        }
      } else {
        this.$message.error(res.message)
      }
    })



  },
}
</script>

<style lang="less" scoped>
.ss {
  height: 100%;
  width: 100%;
  overflow: hidden;
  #ss_pie1 {
    height: 100%;
    width: 45%;
  }
  .right {
    width: 55%;
    overflow: hidden;
    .title {
      text-align: center;
      margin-bottom: 10%;
    }
    .numberbox {
      text-align: center;
      span {
        display: inline-block;
        background: rgba(0, 0, 0, 0.1);
        box-shadow: 0 0 5px rgba(0, 188, 255, 0.8) inset;
        border-radius: 5px;
        overflow: hidden;
        font-family: 'DS-DIGI';
        font-size: 1.7rem;
        margin: 3px;
        color: #fff;
        font-weight: normal;
        border: 1px solid transparent;
        width: 1.6rem;
        height: 2.1rem;
        line-height: 2.1rem;
        text-align: center;
        background-clip: padding-box, border-box;
        background-origin: padding-box, border-box;
        background-image: linear-gradient(#0720a0, #0720a0),
          linear-gradient(#0720a0, #00bcff);
      }
    }
  }
}
</style>